import React from 'react'
import { withPrefix } from 'gatsby'
import { Helmet } from 'react-helmet'
import { ComoMeCambioDeFondo, QuePasaConMiTipoFondoAlCumplir60Anios, TramiteRealizarMantenerMiTipoFondoActual } from '../../../../components/aportes-y-fondo/tipos-de-fondo/cambia-de-fondo'
import s from '../index.module.css'

const Content = () => {
  return (
    <>
      <Helmet>
        <title>
          Cambia de fondo de pensiones y optimiza tu futuro financiero | Prima AFP
        </title>
        <meta
          name="title"
          content="Cambia de fondo de pensiones y optimiza tu futuro financiero | Prima AFP"
          data-react-helmet="true"
        />
        <meta
          name="description"
          content="Optimiza tu futuro financiero. Elige el fondo de AFP que mejor se adapte a tus necesidades."
          data-react-helmet="true"
        />
        <link rel="canonical" href="https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-fondo/cambia-de-fondo/" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Inicio",  "item": "https://www.prima.com.pe/public-zone/"
                },
                {
                  "@type": "ListItem",
                  "position": 2,
                  "name": "Aportes y Fondo",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/"
                },
                {
                  "@type": "ListItem",
                  "position": 3,
                  "name": "Tipos de Fondo",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-fondo/"
                },
                {
                  "@type": "ListItem",
                  "position": 4,
                  "name": "Cambia de Fondo",  "item": "https://www.prima.com.pe/public-zone/aportes-y-fondo/tipos-de-fondo/cambia-de-fondo/"
                }
              ]
            }
          `}
        </script>
      </Helmet>

      <section className="tw-pt-12 tw-pt-20@lg tw-pb-12 tw-pb-12@lg">
        <ComoMeCambioDeFondo />
      </section>

      <section className={`${s.bgSection1}`}>
        <QuePasaConMiTipoFondoAlCumplir60Anios />
      </section>

      <section className={'bg-gray-6'}>
        <div className={'containerWrap'}>
          <div className={`flex@lg`}>
            <div className={`w-100 w-50@lg tw-pr-2@lg tw-pt-12 tw-pt-20@lg tw-mt-4@lg tw-pr-4@lg`}>
              <h2 className="font-family-secondary c-gray--4 fw-7 tw-f-24 tw-f-24@lg tw-mb-6 tw-mb-2@lg center left@lg">
                ¿Qué pasa con mi tipo de fondo al cumplir 65 años?
              </h2>

              <div className="font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg center left@lg">
                <p className="tw-mb-4">
                  Tu fondo cambia automáticamente al tipo de fondo 0 para
                  disminuir todo riesgo que pueda afectar tu pensión de
                  jubilación.
                </p>

                <p>
                  Por eso, la ley establece que al cumplir 65 años** tu dinero
                  sea cambiado al fondo más conservador. Sin embargo, si lo
                  deseas, en el mismo mes que cumples 65 años puedes solicitar
                  mantenerte en tu fondo actual. A partir de los 65 años, los
                  únicos tipos de fondo permitidos son el Fondo 0, 1 y 2.
                </p>
              </div>
            </div>

            <div className={`w-auto w-50@lg tw-pt-12 tw-pt-16@lg`}>
              <img
                src={withPrefix('/images/woman-piggy-bank.svg')}
                alt="woman-piggy-bank"
                className={`${s.imagenBox2}`}
              />
            </div>
          </div>
        </div>
      </section>

      <section className={`containerWrap`}>
        <TramiteRealizarMantenerMiTipoFondoActual />
      </section>
    </>
  )
};

export default Content;
